import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export const iconButtonStyles = cva('rounded-[8px] border hover:bg-gray-100 ', {
  variants: {
    color: {
      danger: ['text-red-500 fill-current'],
      blue_900: ['text-blue-900'],
      grey_700: ['text-grey-700 border-grey-700'],
      default: ['hover:border-blue-100 border-transparent'],
    },
    disabled: {
      false: ['cursor-pointer'],
      true: ['cursor-not-allowed', 'opacity-50'],
    },
    size: {
      small: ['w-[36px] h-[36px]'],
      medium: ['w-[40px] h-[40px]'],
      xl: ['w-[44px] h-[44px]'],
    },
  },
  defaultVariants: {
    color: 'default',
  },
});

export type IconButtonStyleProps = VariantProps<typeof iconButtonStyles>;